<template>
	<div>
		<md-tabs class="md-transparent">
			<md-tab v-for="(config, idx) in wizardKeys" v-bind:key="`key-${idx}`" :id="`tab-${idx}`" :md-label="`${config[1]}s`">
				<configuration-editor :configKey="config[0]" :columnTitle="config[1]" :inputType="config[2]"></configuration-editor>
			</md-tab>
		</md-tabs>
	</div>
</template>
<script>
import configurationEditor from "./ConfigurationEditor";
export default {
	components: {
		configurationEditor
	},
	data() {
		return {
			wizardKeys: [['wizard-headlines', 'Headline', 'input'],
				['wizard-intros', 'Introduction', 'textarea'],
				['wizard-contents', 'Question', 'textarea'],
				['wizard-closes', 'Thank you', 'input'],
				['wizard-prompts', 'Prompt', 'textarea']]
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/ConfigurationWizard.vue